module.exports = __webpack_public_path__ + "media/images/confetti-bg-96036df3.png";